import { Children, Fragment } from 'react'
import { cn, resolveSize } from './internal/utils'

const ALIGN = {
  start: 'items-start',
  end: 'items-end',
  center: 'items-center',
  baseline: 'items-baseline',
}

/**
 * antd Space. Uses flex `gap` rather than injected spacer elements, so a wrapping
 * row spaces correctly on both axes.
 */
const Space = ({
  direction = 'horizontal',
  size = 'small',
  align,
  wrap = false,
  split,
  className,
  style,
  children,
  ...rest
}) => {
  const isVertical = direction === 'vertical'
  const [gapX, gapY] = Array.isArray(size)
    ? [resolveSize(size[0]), resolveSize(size[1])]
    : [resolveSize(size), resolveSize(size)]

  const items = Children.toArray(children).filter((child) => child !== null && child !== false)

  return (
    <div
      className={cn(
        'ui-space inline-flex',
        isVertical ? 'ui-space-vertical flex-col' : 'ui-space-horizontal flex-row',
        wrap && 'flex-wrap',
        align ? ALIGN[align] : !isVertical && 'items-center',
        className
      )}
      style={{ columnGap: gapX, rowGap: isVertical ? gapY : gapY, ...style }}
      {...rest}
    >
      {items.map((child, index) => (
        // eslint-disable-next-line react/no-array-index-key -- positional, matches antd
        <Fragment key={index}>
          <div className="ui-space-item">{child}</div>
          {split && index < items.length - 1 ? (
            <span className="ui-space-item-split">{split}</span>
          ) : null}
        </Fragment>
      ))}
    </div>
  )
}

const Compact = ({ direction = 'horizontal', className, children, ...rest }) => (
  <div
    className={cn(
      'ui-space-compact inline-flex',
      direction === 'vertical' ? 'flex-col' : 'flex-row items-center',
      className
    )}
    {...rest}
  >
    {children}
  </div>
)

Space.Compact = Compact

export default Space
